function transformObjKeysToUpperCase(obj) {
  if (typeof obj !== 'object' || obj === null) {
    return obj
  }

  let transformedObj = Array.isArray(obj) ? [] : {}

  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      let upperKey = key.toUpperCase()

      if (typeof obj[key] === 'object' && obj[key] !== null) {
        transformedObj[upperKey] = transformObjKeysToUpperCase(obj[key])
      } else {
        transformedObj[upperKey] = obj[key]
      }
    }
  }

  return transformedObj
}

export default transformObjKeysToUpperCase

/* Example:
const example = {
  a: 1,
  b: {
    c: 2,
    d: {
      e: 3,
    },
  },
  f: [4, 5, { g: 6 }],
}

console.log(transformKeysToUpper(example))
  { A: 1, 
    B: { 
      C: 2, 
      D: { 
        E: 3,
      }
    },
    F: [4, 5, { G: 6 }], 
  } 
*/
